/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { ChartTypes } from '../Components/ChartTypes';
import AnalyticsHeader from '../AnalyticsHeader';
import { AnalyticsContext } from '../Context/AnalyticsContext';
import DashedLineChart from '../Components/DashedLineChart';
import ColumnChart from '../Components/ColumnChart';
import ColumnAndLineChart from '../Components/ColumnAndLineChart';
import { NONE, PREVIOS_PERIOD } from '../AnalyticsConstants';
import SynchronizedCharts from '../Charts/SynchronizedCharts';
import CompatioLoader from 'Components/Common/components/CompatioLoader';

type TDetailPageProps = {
    metricName?: string;
}

const AnalyticsDetailPage = ({ metricName }: TDetailPageProps) => {
    const context = useContext(AnalyticsContext);
    const [firstTime, setFirstTime] = useState<boolean>(true);
    const [selectedChartItem, setSelectedChartItem] = useState<string>("Line Chart");

    const metric = context.graphData.find((graph: any) => graph.metric_name === metricName);

    useEffect(() => {
        context.ensureDefaultApplication();
    }, [])

    useEffect(() => {
        context.ensureDefaultApplication();
        if (context.payload.applications.length > 0 && context.payload.dateRange.length > 1 && context.payload.merchant_key.length > 0) {
            if (firstTime) {
                setTimeout(() => {
                    setFirstTime(false);
                }, 2000);
                return;
            }
            context.setShowGraphLoader(true);
            context.fetchGraphData();
        }
    }, [context.payload]);

    return (
        <React.Fragment>
            <AnalyticsHeader detailPage={true} pageTitle={metricName ?? "Performance Details Page"} />
            <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} />
            {context.showGraphLoader ? <CompatioLoader /> : null}
            {!context.showGraphLoader && metric?.chartData.length > 0 && metric?.combinedData.length > 0 ? <div className={`tw-rounded tw-mt-3 tw-bg-greys-000 tw-shadow-[0px_4px_12px_rgba(0,_0,_0,_0.08)] tw-box-border tw-w-full tw-h-auto tw-border-[1px] tw-border-solid tw-border-lightgray`}>
                <div className={`tw-flex tw-justify-between tw-pt-2 tw-px-2`}>
                    <label className={`tw-text-sm tw-ps-1 tw-font-medium tw-text-[#091E42]`}>{metric.metric_name}</label>
                    {context.selectedCompareMenuItem === NONE ? <div className={`tw-flex tw-gap-4 tw-pe-2`}> <ChartTypes selectedItem={selectedChartItem} setSelectedItem={setSelectedChartItem} /></div> : null}
                </div>
                <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6] tw-mt-2`} />
                {context.selectedCompareMenuItem === PREVIOS_PERIOD && metric && metric?.chartData.length > 0 && selectedChartItem === "Line Chart" ? <SynchronizedCharts data={metric.chartData} dashedArray={metric.dashedArray} metricName={metric.metric_name} xAxis={metric?.xAxis} granularity={context?.payload?.granularity} timezone={context?.selectedTimezone?.name} /> : null}
                {context.selectedCompareMenuItem === NONE && metric && selectedChartItem === "Line Chart" ? <DashedLineChart data={metric?.chartData} dashedArray={metric.dashedArray} metricName={metric.metric_nam} xAxis={metric?.xAxis} granularity={context?.payload?.granularity} timezone={context?.selectedTimezone?.name} /> : null}
                {context.selectedCompareMenuItem === NONE && metric && selectedChartItem === "Column Chart" ? <ColumnChart data={metric?.chartData} metricName={metric.metric_nam} xAxis={metric?.xAxis} granularity={context?.payload?.granularity} timezone={context?.selectedTimezone?.name} /> : null}
                {context.selectedCompareMenuItem === NONE && metric && selectedChartItem === "Line & Column" ? <ColumnAndLineChart data={metric?.combinedData} xAxis={metric?.xAxis} granularity={context?.payload?.granularity} timezone={context?.selectedTimezone?.name} /> : null}
            </div> : null}
        </React.Fragment>
    );
}

export default AnalyticsDetailPage;